import { SmartusComponentsModule } from '@affinis/smartus-components';
import { Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-link',
  imports: [SmartusComponentsModule, FormlyModule],
  template: `
    @if (field.props?.icon) {
      <su-icon class="m-x-8" [icon]="field.props?.icon"></su-icon>
    }
    <a [href]="field.props?.href">{{ field.props?.label }}</a>
  `,
})
export class FormlyLinkComponent extends FieldType {}
